import {
	getLoadingsRatioTotal,
	getLoadingCode,
	getExclusionCode
} from "./helpers.js"

import dayjs from "dayjs"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

const header = [
	["Template 09 - Record of policies with Premium Loading/CBE"],
	[
		"VHIS Cert No.",
		"Age",
		"Sex",
		"Underwriting/ Re-underwriting result",
		"Level of Premium Loading Rate (%)",
		"Reason for Premium Loading 1",
		"Reason for Premium Loading 2",
		"Reason for Premium Loading 3",
		"Reason for Premium Loading 4",
		"Reason for Premium Loading 5",
		"Reason for CBE 1",
		"Reason for CBE 2",
		"Reason for CBE 3",
		"Reason for CBE 4",
		"Reason for CBE 5"
	]
]

// Return calculated age
const getAge = policy => {
	const dateOfBirth = policy?.contractInsured?.[0]?.dateOfBirth
	const currentYear = dayjs().year()
	const yearOfBirth = dayjs(dateOfBirth).year()
	return currentYear - yearOfBirth
}

const rows = payload => {
	let output = []
	payload.map(policy => {
		const underwritingResult = getUnderwritingResult(policy)
		const loadings = policy?.premium?.loadings
		const exclusions = policy?.exclusions

		if (underwritingResult != null)
			output.push([
				policy?.product?.productId?.plan,
				getAge(policy),
				policy?.contractInsured?.[0]?.gender,
				underwritingResult,
				getLoadingsRatioTotal(loadings) * 100,
				getLoadingCode(loadings, 0),
				getLoadingCode(loadings, 1),
				getLoadingCode(loadings, 2),
				getLoadingCode(loadings, 3),
				getLoadingCode(loadings, 4),
				getExclusionCode(exclusions, 0),
				getExclusionCode(exclusions, 1),
				getExclusionCode(exclusions, 2),
				getExclusionCode(exclusions, 3),
				getExclusionCode(exclusions, 4)
			])
	})
	return output
}

const getUnderwritingResult = policy => {
	const status = policy.status
	const loadings = policy?.premium?.loadings?.length > 0 ? true : false
	const exclusions = policy?.exclusions?.length > 0 ? true : false

	if (status === "ISSUED" && loadings === true && exclusions === false)
		return "Offer with Premium Loading only"
	if (status === "ISSUED" && loadings === false && exclusions === true)
		return "Offer with CBE only"
	if (status === "ISSUED" && loadings === true && exclusions === true)
		return "Offer with Premium Loading and CBE only"
}

const fetchData = async filterPayload => {
	const query = gql`
		query fetchTemplate09Payload($policyWhere: policyWhereInput) {
			policies(where: $policyWhere) {
				list {
					status
					product {
						productId {
							plan
						}
					}
					contractInsured {
						... on individual {
							gender
							dateOfBirth
						}
					}
					premium {
						loadings {
							id
							codeName {
								code
								name
							}
							ratio
						}
					}
					exclusions {
						id
						codeName {
							code
							name
						}
					}
				}
			}
		}
	`
	const variables = {
		policyWhere: filterPayload
	}

	const res = await api({ query, variables })

	return res?.data?.policies?.list
}

export default async filterPayload => {
	const fetchedData = await fetchData(filterPayload)
	const workSheetData = [...header, ...rows(fetchedData)]
	const workSheetColumns = [
		{ wpx: 150 },
		{ wpx: 50 },
		{ wpx: 50 },
		{ wpx: 300 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 },
		{ wpx: 200 }
	]
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}
